import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { FAQ_ITEMS } from '../data/capabilities';
import AnimatedSection from './AnimatedSection';
import './FAQSection.css';

const FAQSection = () => {
  const [open, setOpen] = useState(0);
  const reduceMotion = useReducedMotion();

  return (
    <section className="faq section" id="faq">
      <div className="container faq-layout">
        <AnimatedSection className="faq-intro">
          <p className="section-label">/ FAQs</p>
          <h2 className="section-title">The questions we get most</h2>
        </AnimatedSection>

        <div className="faq-list">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className={`faq-item ${isOpen ? 'open' : ''}`}>
                <button
                  type="button"
                  className="faq-q"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>
                    {i + 1}. {item.q}
                  </span>
                  <span className="faq-icon" aria-hidden="true">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="faq-a"
                      initial={reduceMotion ? false : { height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={reduceMotion ? undefined : { height: 0, opacity: 0 }}
                      transition={{ duration: 0.28 }}
                    >
                      <p>{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
